import React from "react";
import { Col, Row } from "reactstrap";
import { FormLabel, RequiredIndicator } from "assets/js/Styles";
import { Toast } from "utility/helpers";
import styled from "styled-components";
import CustomDropzone from "./Dropzone";
import { acceptedFileTypes } from "./constants";

const HouseMemberSection = styled(Row)`
  margin-top: 1rem;
  display: flex;
  justify-content: space-between;
`;

const HouseMemberColRight = styled.div`
  display: grid;
  grid-template-columns: 0.83fr;

  @media screen and (max-width: 575.98px) {
    grid-template-columns: 1fr;
    row-gap: 12px;
  }
`;

const SupportingDocumentsSection = ({ uploadedFiles, setUploadedFiles }) => {
  const handleUploadedFiles = (link) => {
    setUploadedFiles((prevUploadedFiles) => {
      const fileIndex = prevUploadedFiles.findIndex(
        (file) => file.name === link.name
      );

      if (fileIndex !== -1) {
        const updatedFiles = [...prevUploadedFiles];
        updatedFiles[fileIndex] = link;

        return updatedFiles;
      }

      if (prevUploadedFiles.length < 5) {
        return [...prevUploadedFiles, link];
      }

      Toast({
        type: 4,
        content: "Exceeded file upload limit of 5",
      });

      return prevUploadedFiles;
    });
  };

  const handleDeleteFile = (file) => {
    const newUploadedFiles = uploadedFiles.filter(
      (files) => files.name !== file
    );
    setUploadedFiles(newUploadedFiles);
  };

  return (
    <HouseMemberSection>
      <Col
        xs="12"
        md="6"
      >
        <FormLabel>
          {"Supporting Documents"}
          {RequiredIndicator}
        </FormLabel>
        <p>{"Please provide the Qualification Map of the TVI"}</p>
      </Col>
      <Col
        xs="12"
        md="6"
      >
        <HouseMemberColRight>
          <CustomDropzone
            handleUploadedFiles={handleUploadedFiles}
            handleDeleteFile={handleDeleteFile}
            uploadedFiles={uploadedFiles}
            label="Upload Attachments"
            acceptedFileTypes={acceptedFileTypes}
            acceptedFileTypeErrorMsg="Accepted files are only xls, xlxs, and pdf."
          />
        </HouseMemberColRight>
      </Col>
    </HouseMemberSection>
  );
};

export default SupportingDocumentsSection;
